import React, { useEffect, useState } from "react"
import { useAppDispatch } from "../../../store"
import { setCurrentPage } from "../../../store/auth/authReducer"
import Table from "../../../components/Table/Table"
import LinearProgress from "@mui/material/LinearProgress"
import axios from "axios"
import { Link } from "react-router-dom"
import Button from "@mui/material/Button"
import Box from "@mui/material/Box"
import TextField from "@mui/material/TextField"
import { logOut } from "../../../utils/logOut"
import dayjs from "dayjs"
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { DatePicker } from "@mui/x-date-pickers/DatePicker"
import FormControl from "@mui/material/FormControl"
import InputLabel from "@mui/material/InputLabel"
import MenuItem from "@mui/material/MenuItem"
import Select from "@mui/material/Select"
import { useSelector } from "react-redux"
import { Fade, Typography } from "@mui/material"
import SimplifiedTable from "../../../components/Table/SimpleTable"
import TranslatedText from "../../../utils/Translate"
import { useSnackbar } from "../../../utils/SnackbarContext"
import { DateTimePicker } from "@mui/x-date-pickers"

export default function SystemLog() {
    const dispatch = useAppDispatch()
    const [tableData, setTableData] = useState([])
    const [loading, setLoading] = useState(false)
    const [partners, setSPartners] = useState([])
    const [startRow, setStartRow] = useState(0)
    const [pageRows, setPageRows] = useState(100)
    const [maxRows, setMaxRows] = useState(pageRows)
    const [totalRows, setTotalRows] = useState(0)

    const { showSnackbar } = useSnackbar();

    dayjs.extend(utc);
    dayjs.extend(timezone);
    dayjs.tz.setDefault('Europe/Moscow');

    //Get current date for using it default in filters
    const today = new Date();
    const nextDay = new Date();
    const [filterParams, setFilterParams] = useState<any>({
        df: dayjs(today).tz('Europe/Moscow').format('YYYY-MM-DD HH:mm'),
        dt: dayjs(nextDay.setDate(today.getDate() + 1)).tz('Europe/Moscow').format('YYYY-MM-DD HH:mm'),
        partnerbank: '',
        ip: '',
        url: '',
        method: ''
    })

    useEffect(() => {
        dispatch(setCurrentPage(`System Log`))
    }, [dispatch]);

    const accesslevel = useSelector(
        (state: any) => state.auth.authData.accesslevel
    )

    //Get Login Report data
    async function fetchData(params: object = {}) {
        setLoading(true)
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/systemlog`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: {
                    df: filterParams.df ? filterParams.df : null,
                    dt: filterParams.dt ? filterParams.dt : null,
                    partnerbank: filterParams.partnerbank,
                    ip: filterParams.ip,
                    url: filterParams.url,
                    method: filterParams.method,
                    startRow,
                    maxRows,
                    calculatetotalcount: true
                }
            })
            if (response.data !== null) {
                if (typeof (response.data) === 'object') {
                    setTotalRows(+response.data[0].totalcount)
                    setTableData(response.data.slice(1))
                }
                else showSnackbar('ERROR: INVALID SERVER RESPONSE', 'error')
            }

            console.log(response.data);

            setLoading(false)
        } catch (error: any) {
            console.log(error);
            if (error.code === "ERR_BAD_REQUEST") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
            setLoading(false)
        }
    }

    //Get partners for Select field
    async function getPartners(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/partner`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            console.log(response.data);
            setSPartners(response.data)
        } catch (error: any) {
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }
    //on load - fetch data
    useEffect(() => {
        setTimeout(() => fetchData(filterParams), 0)
        if (accesslevel === '1' || accesslevel === "5") {
            getPartners()
        }
    }, [startRow, maxRows])


    //Pagination buttons
    function handleBack() {
        if ((startRow - pageRows) < 0) {
            setStartRow(0)
            setMaxRows(pageRows)

        }
        else {
            setStartRow((prev) => prev - pageRows)
            setMaxRows((prev) => prev - pageRows)
        }
    }

    function handleNext() {

        setStartRow((prev) => prev + pageRows)
        setMaxRows((prev) => prev + pageRows)

    }

    function handleEnd() {

        setStartRow(totalRows % pageRows === 0 ? totalRows - pageRows : totalRows - (totalRows % pageRows))
        setMaxRows(totalRows % pageRows === 0 ? totalRows : totalRows - (totalRows % pageRows) + pageRows)

    }

    function handleStart() {

        setStartRow(0)
        setMaxRows(pageRows)

    }

    const totalPages = Math.ceil(totalRows / pageRows);
    const currentPage = Math.ceil(maxRows / pageRows);



    return (
        <Box sx={{ height: '86vh', display: 'flex', flexDirection: 'column', mr: 1 }}>
            <Box sx={{ mb: 3, alignItems: "center", display: 'flex', width: "100vw", justifyContent: "space-between" }}>
                <Box></Box>
                <Box sx={{ display: "flex", alignItems: "center", gap: 2, mr: 15 }}>
                    {(accesslevel === '1' || accesslevel === "5") && <FormControl>
                        <InputLabel size="small" id="simple-select-label"><TranslatedText text={'Partner'} /></InputLabel>
                        <Select sx={{ width: 223 }} labelId="simple-select-label" value={filterParams.partnerbank} onChange={(e) => setFilterParams({ ...filterParams, partnerbank: e.target.value })} variant="outlined" size="small" label={<TranslatedText text={'Partner'} />} >
                            <MenuItem value={''}><TranslatedText text={'All'} /></MenuItem>
                            <MenuItem value={'0'}><TranslatedText text={'Operators'} /></MenuItem>
                            {
                                partners.map((el: any) => {
                                    return (
                                        <MenuItem key={el.id} value={el.id}>{el.partnerbankcode}</MenuItem>
                                    )
                                })
                            }
                        </Select>
                    </FormControl>}
                    <DateTimePicker label={<TranslatedText text={'Date From'} />} sx={{ width: 223 }} slotProps={{ textField: { size: 'small' } }} value={dayjs(filterParams.df)} onChange={(e) => {
                        if (!e || !e.isValid()) return;
                        setFilterParams({ ...filterParams, df: e ? e.tz('Europe/Moscow').format('YYYY-MM-DD HH:mm') : '' });
                        }} format='YYYY-MM-DD HH:mm' />
                    <DateTimePicker label={<TranslatedText text={'Date To'} />} sx={{ width: 223 }} slotProps={{ textField: { size: 'small' } }} value={dayjs(filterParams.dt)} onChange={(e) => {
                        if (!e || !e.isValid()) return;
                        setFilterParams({ ...filterParams, dt: e ? e.tz('Europe/Moscow').format('YYYY-MM-DD HH:mm') : '' });
                        }} format='YYYY-MM-DD HH:mm' />
                    <TextField sx={{ minWidth: 220 }} value={filterParams.ip} onChange={(e) => setFilterParams({ ...filterParams, ip: e.target.value })} variant="outlined" size="small" label={'IP'} />
                    <TextField sx={{ minWidth: 220 }} value={filterParams.url} onChange={(e) => setFilterParams({ ...filterParams, url: e.target.value })} variant="outlined" size="small" label={'URL'} />
                    <TextField sx={{ minWidth: 220 }} value={filterParams.method} onChange={(e) => setFilterParams({ ...filterParams, method: e.target.value })} variant="outlined" size="small" label={<TranslatedText text={'Method'} />} />
                    
                    <Button onClick={() => fetchData(filterParams)} size="small" sx={{ mr: 1 }} variant="contained" ><TranslatedText text={'Apply'} /></Button>
                </Box>
                <Box></Box>
            </Box>
            {loading ? <LinearProgress sx={{ width: "50%", marginTop: '33vh', marginLeft: 'auto', marginRight: 'auto' }} /> :
                <>
                    <SimplifiedTable rows={tableData} page={'loginreport'} />
                    <Fade in={!loading} timeout={300}>
                        <Box sx={{ display: 'flex', alignItems: "center", marginTop: 'auto' }}>
                            <Box sx={{ mt: 2 }}>
                                <Button disabled={startRow === 0} onClick={() => handleStart()} size="small" sx={{ mr: 1 }} variant="outlined" >{"<<"}</Button>
                                <Button disabled={startRow === 0} onClick={() => handleBack()} size="small" sx={{ mr: 1 }} variant="outlined" ><span>{'<'}&nbsp;</span> {<TranslatedText text={"Back"} />}</Button>
                                <Button disabled={maxRows >= totalRows} onClick={() => handleNext()} size="small" sx={{ mr: 1 }} variant="outlined" >{<TranslatedText text={'Next'} />}&nbsp;<span>{'>'}</span></Button>
                                <Button disabled={maxRows >= totalRows || tableData.length < pageRows} onClick={() => handleEnd()} size="small" sx={{ mr: 1 }} variant="outlined" >{">>"}</Button>
                            </Box>
                            <Typography sx={{ pt: 2, ml: 2 }}><TranslatedText text={'Rows on page:'} /> {pageRows}</Typography>
                            <Typography sx={{ pt: 2, ml: 2 }}>
                                <TranslatedText text={'Page:'} /> {currentPage} / {totalPages}
                            </Typography>
                            <Typography sx={{ pt: 2, ml: 2 }}><TranslatedText text={'Total rows:'} /> {totalRows}</Typography>
                        </Box>
                    </Fade>
                </>
            }
        </Box>
    )
}